import { Box, List, makeStyles } from '@material-ui/core';
import React from 'react';
import Warrants from './Warrants';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: window.innerHeight - 90 + 'px',
    paddingTop: theme.spacing(1),
  },
  panel: {
    height: '100%',
    overflow: 'auto',
    display: 'block',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
  },
}));

function WarrantsSearch(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <List className={classes.panel}>
        <Box p={3}>
          <Warrants />
        </Box>
      </List>
    </div>
  );
}

export default WarrantsSearch;
